import { render } from "./OrderStartCard.vue?vue&type=template&id=dbc31f24&scoped=true"
import script from "./OrderStartCard.vue?vue&type=script&lang=js"
export * from "./OrderStartCard.vue?vue&type=script&lang=js"

import "./OrderStartCard.vue?vue&type=style&index=0&id=dbc31f24&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbc31f24"]])

export default __exports__